<template>
  <div>
    <van-nav-bar
      title="待收款"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div v-if="loading" style="padding:30px 0;text-align:center;">
        <van-loading>加载中...</van-loading>
      </div>
      <template v-else>
        <van-empty v-if="!list.length" description="暂无待确认的收款" />
        <van-panel
          v-for="item in list"
          :key="item.kind + '-' + item.id"
          :title="item.title"
          :status="item.status_txt"
          style="margin-bottom:12px;"
        >
          <div class="orderCon">
            <div>金额：<b style="color:#ff6600;">￥{{item.pay}}</b></div>
            <div>提交时间：{{item.create_time}}</div>
            <div class="tip" v-if="item.status === 10">已在微信中为你准备好，请在 24 小时内确认收款，逾期将自动退回</div>
            <div class="tip" v-else>点下方按钮后，微信会引导你确认收款</div>
          </div>
          <div slot="footer" class="confirmBox">
            <van-button
              size="small"
              type="primary"
              round
              :loading="pendingKey === (item.kind + '-' + item.id)"
              @click="confirm(item)"
            >{{ item.status === 10 ? '去微信确认收款' : '立即收款' }}</van-button>
          </div>
        </van-panel>
      </template>
    </van-pull-refresh>
  </div>
</template>

<script>
import * as ajax from '@/api/common'
import { confirmReceipt } from '@/libs/transfer'
export default {
  name: 'pendingReceiptPage',
  data() {
    return {
      list: [],
      total: 0,
      loading: true,
      isLoading: false,
      pendingKey: ''
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    load () {
      this.loading = true
      ajax.get('/Pay/pendingReceipts', { showTips: false, showLoading: false }).then(res => {
        this.loading = false
        this.isLoading = false
        this.list = (res && res.list) ? res.list : []
        this.total = (res && res.total) ? res.total : 0
      }).catch(e => {
        this.loading = false
        this.isLoading = false
        this.$toast((e && e.msg) || '加载失败')
      })
    },
    onRefresh () {
      this.isLoading = true
      this.load()
    },
    confirm (item) {
      if (this.pendingKey) return
      this.pendingKey = item.kind + '-' + item.id
      confirmReceipt({ kind: item.kind, id: item.id }, {
        onSuccess: () => {
          // 仅代表确认页正常返回，不代表已到账（到账以服务端回调为准）
          this.$toast('已提交，到账结果请稍后查看')
          setTimeout(() => this.load(), 1500)
        },
        onCancel: () => {
          this.$toast('你取消了收款')
        },
        onError: msg => {
          this.$toast(msg)
          // 状态可能已变化（已到账 / 已失败），刷新列表
          this.load()
        },
        onDone: () => {
          this.pendingKey = ''
        }
      })
    }
  }
}
</script>

<style scoped>
.orderCon{padding:10px 20px;line-height:22px;font-size:14px;}
.orderCon .tip{color:#999;font-size:12px;margin-top:4px;}
.confirmBox{text-align:right;}
</style>
